module.exports = __webpack_public_path__ + "img/Icon_Info_filled.dfaa132d.svg";